import React from "react";
import Loader from 'react-loader-spinner'
import { Collapse } from 'react-collapse'
import Modal from '../../components/Modal'
import { checkPermission, checkTranslation, pathMaker, setObject, translate } from "../../utils/useful";
import RemoveModal from "../../modals/RemoveModal";
import ItemModal from "../../modals/ItemModal";
import FilterModal from "../../modals/FilterModal";
import HttpServices from "../../utils/Http.services";
import ProfileImage from "../../components/partials/ProfileImage";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';


class AdminTreeApplet extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            fullData: [],
            cloneData: [],
            removeData: null,
            page: null,
            modalIsOpen: false,
            actions: [{ title: '{{lang}}Add', action: 'add', color: '#222', bg: '#efefef' }, { title: '{{lang}}Edit', action: 'edit', color: '#fff', bg: '#0847a5' }, { title: '{{lang}}Remove', action: 'remove', color: '#fff', bg: '#ff5249' }],
            actionIndex: null,
            filterItem: { values: {} },
            selectedIndex: null,
            isLoading: false,
            collapses: {},
            query: ''

        }
    }



    openEditModal = (prop, index) => {
        if (this.props.page?.addNew && this.props.page?.addNew != -1) {

            if (this.props.page?.addNew?.function) {
                if (this[this.props.page?.addNew?.function]) {
                    this[this.props.page?.addNew?.function]()
                }

            } else if (this.props.page?.addNew?.page) {
                let newPage = this.props.route + this.props.page?.addNew.page
                this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            }
            else {
                let newPage = this.props.page?.addNew
                if (this.props.page?.addNew?.includes('../')) {
                    newPage = this.props.route + this.props.page?.addNew.replace('..', '')
                }
                this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            }
        } else {
            console.log('herrrrreeeeTP')
            this.itemModal.modal.showModal()
            this.setState({ currentItem: prop, currentIndex: index })
        }
    }



    componentWillMount() {
        this.setState({ innerWidth: window.innerWidth })
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ innerWidth: window.innerWidth, height: window.innerHeight });
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }



    componentDidMount() {
        this.setState({ query: '' })
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            this.setState({ query: '' })
            this.init()
        }
    }

    init() {
        if (this.props.page) {
            this.setState({ showTable: false, selectedTab: null, data: [], totalCount: null, filters: null, filter: {}, filter2: {} }, () => {
                this.fetchData(true)
            })
        }
    }

    fetchData = (getCount) => {

        this.setState({ isLoadingData: true })
        let body = this.props.page.filter ?? {}
        let page = this.props.page
        body.page = page.key
        body.limit = this.state.limit
        body.skip = this.state.currentPage
        body.filter = this.state.filter ?? {}

        if (this.state.filter2) {
            body.filter2 = this.state.filter2
        }

        if (this.props.page.postBody) {
            body.filter = { ...body.filter, ...this.props.page.postBody }
        }

        if (this.props.page.populate) {
            body.populate = this.props.page.populate
        }

        if (this.props.page.sort) {
            body.sort = this.props.page.sort
        }


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        if (this.state.totalCount == null || getCount) {
            body.getCount = true
        }

        console.log(body)
        // console.log('page.fetchUrlpage.fetchUrl', page.fetchUrl)
        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            // console.log(fetchError)
            // console.log(fetchResult)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // console.log(fetchResult)
            let formedData = []
            console.log('fetchResult.info', fetchResult.info)
            fetchResult.info.forEach(element => {
                // console.log('elementss', element)
                if (element.parent == '' || element.parent == null) {
                    formedData.push(element)
                }
            });


            formedData.forEach(parent => {
                this.findChildren(parent, fetchResult.info)
            });

            // console.log(formedData)

            this.setState({ data: formedData, cloneData: formedData, fullData: fetchResult.info })


            if (fetchResult.count != null) {
                this.setState({ totalCount: fetchResult.count })
            }
        })
    }

    findChildren(parent, ref) {
        let children = []
        ref.forEach(element => {
            let myParent = parent
            let myId = element.parent

            if (typeof myParent == 'object') {
                myParent = myParent?._id
            }
            if (typeof myId == 'object') {
                myId = myId?._id
            }

            if (myId == myParent) {
                children.push(element)
            }
        });

        if (Array.isArray(children)) {
            children.forEach(child => {
                this.findChildren(child, ref)
            });
        }

        parent.subgroups = children
        return
    }

    itemAdded = (newItem, modalIndex) => {
        this.fetchData(true)
    }





    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem?._id
        HttpServices.request(this.props.page.removeUrl, { "id": id, page: this.props.page.page ?? this.props.page.key }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}Remove Failed'), description: checkTranslation(fetchError.message) })
                return
            }
            let data = this.state.data
            this.fetchData(true)
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}Removed'), description: checkTranslation('{{lang}}Removed Record Successfully') })
        })
    }


    editAction = (item, index) => {

        let newItem = JSON.stringify(item)
        newItem = JSON.parse(newItem)
        console.log("newItem")
        console.log(newItem)
        this.setState({ currentItem: {} }, () => {
            this.setState({ currentItem: newItem })
            this.setState({ selectedIndex: index }, () => {
                console.log(this.state.currentItem)
                console.log('edit last TP')
                this.itemModal.modal.showModal()
                this.setState({ modalIsOpen: true })
            })
        })
    }

    removeAction = (info, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: info, currentIndex: index })
    }

    addAction = (parent, index) => {
        console.log(parent)
        let item = {}
        item = { values: {} }
        this.setState({ currentItem: {} }, () => {
            if (parent || parent == null) {
                item.parent = { _id: parent._id, name: parent.name }
            }
            this.setState({ currentItem: item })
            console.log('currentItemONADD', this.props)
            this.setState({ selectedIndex: -1 }, () => {
                this.itemModal.modal.showModal()
                this.setState({ modalIsOpen: true })
            })
        })

    }


    makeNewItem = () => {
        let helper = null
        let item = {}
        let temp = item

        if (this.props.page.helperKey && this.props.page.helperKey != '') {
            helper = this.props.page.helperKey
            item[helper] = {}
            temp = item[helper]
        }

        this.props.page.headers.forEach(header => {

            if (this.state.lockedItems && this.state.lockedItems[header.key]) {
                temp[header.key] = this.helperCheck(temp, header.key, helper)
            } else {
                if (header.type != 'button') {

                    if (header.information.defaultValue) {
                        temp[header.key] = header.information.defaultValue
                    } else {
                        temp[header.key] = ''
                    }
                }
            }

        });

        return item

    }

    helperCheck(ref, key, helper) {
        if (helper) {
            return ref[helper][key]
        } else {
            return ref[key]
        }
    }


    changeValue = (key, value) => {

        let helper
        if (this.props.page.helperKey && this.props.page.helperKey != '') {
            helper = this.props.page.helperKey
        }

        let newKey = key

        if (helper) {
            newKey = helper + '.' + key
        }

        let currentItem = { ...this.state.currentItem }
        currentItem = setObject(currentItem, newKey, value)
        this.setState({ currentItem })

    }

    changeFiles = (files, key, type) => {
        if (!this.state.currentItem["**files"]) {
            this.state.currentItem["**files"] = {}
        }
        this.state.currentItem["**files"][key] = files
    }

    cancelModal = () => {
        this.setState({ modalIsOpen: false })
    }

    openActionsModal = (index, parentsIndexes, actionItem) => {
        this.setState({ actionIndex: index, actionparentsIndexes: parentsIndexes, actionItem }, () => {
            this.refs.actionsModal.showModal()

        })
    }

    butAction = (index, action) => {
        console.log('btn action', this.state.actionItem)
        this.refs.actionsModal.hideModal()
        switch (action) {
            case 'remove':
                this.removeAction(this.state.actionItem, index)
                break
            case 'edit':
                this.editAction(this.state.actionItem, index)
                break
            case 'add':
                this.addAction(this.state.actionItem, index)
                break
        }
    }

    openFilter = () => {
    }

    changeFilter = (key, value, operator) => {
        if (operator) {
            this.state.filterItem[key].operator = value
        } else {
            this.state.filterItem[key].value = value
        }

    }

    fetchFilter = () => {

    }

    lockSend = () => {
        if (this.state.lockSend) {
            this.setState({ lockedItems: {} })
        }
        this.setState({ lockSend: !this.state.lockSend })
    }

    changeLockItems = (key) => {
        let lockedItems = this.state.lockedItems ? this.state.lockedItems : {}
        lockedItems[key] = lockedItems[key] ? !lockedItems[key] : true
        this.setState({ lockedItems })
    }


    changeCollapse(id) {
        let collapses = this.state.collapses
        collapses[id] = (collapses[id] != null) ? !collapses[id] : false
        this.setState({ collapses })
    }



    groupRow(group, padding, index, parentsIndexes) {
        let newParentsIndexes = parentsIndexes ? [...parentsIndexes] : []
        newParentsIndexes.push(index)

        return (
            <div style={{ paddingRight: padding, paddingLeft: this.state.innerWidth > 600 ? 0 : 0 }}>
                <div style={{ width: '100%', marginTop: 5, backgroundColor: '#f2f6f8', padding: 0, borderRadius: 10, overflow: 'hidden', marginBottom: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 10px 10px 15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 0, marginBottom: 0, borderRadius: 0, }}>
                            <div className={'text-right mr-2 d-flex cursor-pointer'} onClick={() => this.changeCollapse(group._id)}>
                                {group.subgroups && group.subgroups.length > 0 && (
                                    <div className="flexcc" style={{ backgroundColor: '#fff', borderRadius: 5, width: 20, height: 20, }}>
                                        <img className="flexcc" src={(((this.state.collapses[group._id] != null) ? this.state.collapses[group._id] : true) ? '/images/minus.circle.svg' : '/images/plus.circle.svg')} height={20} />
                                    </div>
                                )}
                                <p className="mr-2" style={{ color: '#222', margin: 0, fontSize: 13 }}>{checkTranslation(group.name)}</p>
                            </div>
                        </div>
                        <div className={'d-flex'}>
                            <div onClick={() => this.openActionsModal(index, parentsIndexes, group)} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                <img src="/images/square.and.pencil.svg" height={20} />
                            </div>
                        </div>
                    </div>
                </div>

                {group.subgroups && group.subgroups.length > 0 && (
                    <Collapse isOpened={(this.state.collapses[group._id] != null) ? this.state.collapses[group._id] : true} className="mb-2">
                        {group.subgroups.map((subgroup, sIndex) => {
                            return (
                                this.groupRow(subgroup, padding + this.state.innerWidth > 600 ? 20 : 15, sIndex, newParentsIndexes)
                            )
                        })}
                    </Collapse>
                )}
            </div>
        )
    }




    openAddNew = () => {

        console.log("openAddNew")
        console.log(this.props.page)
        if (this.props.page?.addNew) {
            let newPage = this.props.page?.addNew
            if (this.props.page?.addNew.includes('../')) {
                newPage = this.props.route + this.props.page?.addNew.replace('..', '')
            }
            this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })
        } else {
            this.openEditModal()
        }
    }

    search = (query) => {
        let cloneData = this.state.cloneData
        let fullData = this.state.fullData
        if (query.trim() == '') {
            cloneData = this.state.data
            this.setState({ cloneData, query });
        }
        else {
            let newfullData = fullData.filter((e) => e.name.includes(query))

            let newArr = []
            for (let i = 0; i < newfullData.length; i++) {
                // newArr.push(newfullData[i]._id)
                if (newfullData[i].parent) {

                    this.findParent(newfullData[i].parent, fullData, newArr)
                } else {
                    newArr.push(newfullData[i])

                }
            }
            console.log('newArr', newArr)
            this.setState({ cloneData: newArr, query });
            // })
        }

    };
    findParent = (parentId, fullData, newArr) => {
        // console.log('fullDatas', this.state.fullData)
        for (let i = 0; i < fullData.length; i++) {
            if (fullData[i]._id == parentId) {
                console.log('fullData[i]._id', fullData[i]._id)
                newArr.push(fullData[i])
                this.findParent(fullData[i].parent, fullData, newArr)
            }
        }
    }


    render() {
        return (
            <div>
                <div className="container">
                    <div className="p-4">
                        <div className="col-12 p-0 mb-3" >
                            <div className="p-0" style={{ borderRadius: 0 }}>
                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>
                                    <div className="flexc mt-2">
                                        <ProfileImage width={54} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image ?? this.props.page?.icon }} />
                                        <div>
                                            <p className=" " style={{ color: '#0d172a', fontSize: '17px' }}>{checkTranslation(this.props.page?.title)}</p>
                                        </div>
                                    </div>

                                    <div className="flexcc mt-2" style={{}}>
                                        <div className="w-100 mrd-2" style={{ maxWidth: 300 }}>
                                            <input onChange={(e) => this.search(e.target.value)} value={this.state.query} placeholder={translate('Search')} className="w-100" style={{ height: 40, fontSize: 15, padding: '5px 15px', background: '#f2f6f8', borderRadius: 40, border: '1px solid #fff' }} />
                                        </div>
                                        {this.props.page?.extra && (
                                            <button onClick={() => this.openOptions()} className="flexcc p-0" style={{ height: 40, width: 28, borderRadius: 30, flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                                                <img className="" src="/images/more.svg" alt="" width="24px" />
                                            </button>
                                        )}
                                        {this.props.page?.addNew != -1 && checkPermission(this.props.variables?.permissionRoot + '.create') && (
                                            <button onClick={() => this.openAddNew()} className="flexcc" style={{ boxShadow: '0px 0px 15px #00000005', backgroundImage: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', border: '0px solid #e9eaf0', color: '#fff', borderRadius: 30, padding: '9px 23px' }}>
                                                <img className="mrd-2 invert" src="/images/add.svg" alt="" width="12px" />
                                                <span className="text-smaller m-0 white" >{translate("Add New")} </span>
                                            </button>
                                        )}

                                    </div>
                                </div>


                                {this.state.filter2 && Object(this.state.filter2).length > 0 && (
                                    <div className="flexc mt-2 px-1">
                                        {Object(this.state.filter2).map((prop, index) => {
                                            return (
                                                <div key={index} className="flexcc mrd-1" style={{ backgroundColor: 'rgba(103, 125, 196, 0.082)', color: 'rgba(103, 125, 196, 0.8)', borderRadius: 20, padding: '3px 10px', fontSize: 12, }}>
                                                    {this.filterLabelCreator(prop)}
                                                    <button onClick={() => this.removeFilter(prop)} className="p-0 mld-2" style={{ color: 'rgba(103, 125, 196, 0.8)', fontSize: 12 }}>
                                                        <span className="flexcc">X</span>
                                                    </button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className={"w-100 mediumiransansfont"} >
                            <div className="row">
                                <div className="col-12">
                                    <div className="box p-0 " style={{ backgroundColor: '#fcfcfc', position: 'relative' }}>
                                        <div className="p-2 text-center mb-1" style={{ borderBottom: '#f7f7f7 0px solid' }}>
                                            <div className="w-100 p-2 pb-3 no-scrollbar" style={{ display: 'flex', flexWrap: 'wrap', flex: 1, }}>
                                                {this.state.isLoadingData && (
                                                    <div className="text-center mt-4 flexcc w-100">
                                                        <Loader
                                                            type="ThreeDots"
                                                            color="#789"
                                                            height="60"
                                                            width="60"
                                                        />
                                                    </div>
                                                )}

                                                {this.state.cloneData.map((group, index) => {
                                                    console.log('group-0-0-0-', group)
                                                    return (
                                                        <div key={index} className="p-2" style={{ width: '100%' }}>

                                                            {this.groupRow(group, 0, index, 0)}

                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {this.props.page && (
                    <div>
                        <RemoveModal
                            isLoading={this.state.isLoadingRemove}
                            removeFunction={this.fetchRemove}
                            ref={el => this.removeModal = el}
                        />
                        <ItemModal
                            ref={el => this.itemModal = el}
                            page={this.props.page}
                            headers={this.props.page?.headers}
                            initData={this.state.currentItem}
                            variables={this.props.variables}
                            itemAdded={this.itemAdded}
                            itemEdited={this.itemAdded}
                            openRefModal={this.openRefModal}
                            functionsHandler={this.functionsHandler}
                            showDates={true}
                        />
                        <FilterModal cancelModal={this.cancelModal} fetchFilter={() => this.fetchFilter()} changeValue={this.changeFilter} ref={'filterModal'} headers={this.props.page.headers} item={this.state.filterItem} />
                        <Modal cancelModal={this.cancelModal} className="lightiransansfont" ref={'actionsModal'} maxWidth={250} style={{ alignItems: 'center', textAlign: 'center', display: 'flex', justifyContent: 'center' }} zIndex={1}>
                            <div className="p-4" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                                <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <p style={{ textAlign: 'center', fontSize: 20, marginTop: 0, fontWeight: '500' }}>{translate('Operations')}</p>
                                </div>
                                <div className="mt-3" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                    {this.state.actions.map((prop, index) => {
                                        return (
                                            <div className="mb-2">
                                                <div style={{ flex: 1, flexDirection: 'column', position: 'relative' }} >
                                                    <div onClick={() => this.butAction(this.state.actionIndex, prop.action)} style={{ cursor: 'pointer', padding: 10, paddingLeft: 15, paddingRight: 15, borderRadius: 40, backgroundColor: prop.bg, justifyContent: 'center', alignItems: 'center' }}>
                                                        <p className={'mediumiransansfont'} style={{ margin: 7, color: (prop.color), textAlign: 'center', fontSize: 15, margin: 0 }}>{checkTranslation(prop.title)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </Modal>
                    </div>
                )}
            </div>
        );
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminTreeApplet);
